export default __webpack_public_path__ + "static/media/img4.7dbdd221.png";